import { Navigate, useLocation, useNavigate, useParams } from 'react-router-dom';
import { PageLoader } from '@/layouts/components/PageLoader/PageLoader';
import { CalculatorPage } from '@/features/application/pages/CalculatorPage';
import { useKyc } from '@/features/kyc';
import { routes } from '@/routes/routes';
import { getPreliminaryOffers } from '@/lib/offerUtils';
import { useLoanOffer } from '../../hooks';

/**
 * The calculator of one preliminary offer, opened from its landing: the
 * amount (and the installments' duration) chosen here is saved on the way
 * and shown back on the landing.
 */
export function PreliminaryCalculatorPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { tab } = useParams<{ tab?: 'credit-line' | 'installment' }>();
  const { isKycLoading, isKycValid } = useKyc(true);
  const { loanOfferState, isLoading } = useLoanOffer(true);

  if (isKycLoading || isLoading) {
    return <PageLoader />;
  }

  // With KYC there is nothing left to apply for.
  if (isKycValid || getPreliminaryOffers(loanOfferState?.creditOffers).length === 0) {
    return <Navigate to={routes.offer.preliminary} replace />;
  }

  // Back to the landing it was opened from, without stacking another copy.
  const handleSave = () => {
    if (location.key !== 'default') {
      navigate(-1);
      return;
    }
    navigate(routes.offer.preliminaryDetails(tab ?? 'credit-line'), {
      replace: true,
    });
  };

  return (
    <CalculatorPage isPreliminary onContinue={handleSave} continueText="Salvează" />
  );
}

export default PreliminaryCalculatorPage;
